export default class Route {
    static get() {
        return {
            default_dom_selector: "#container"
        };
    }
}